
export const ReactQueryKeys = {
    PAYMENT_LINK_DATA: "payment-link-data",
    CHECKOUT_DATA: "checkout-data",
    HISTORY: "history",
    LICENSE_PLATES: "license-plates",
    CHECK_PAYMENT_STATUS: "check-payment-status",
    VEHICLES: "vehicles",
    VEHICLE_REQUEST_TRANSFER: "vehicle-request-transfer",
    TOLL_OPERATORS: "toll-operators",
    WHITELABEL: "whitelabel",
    CONFIRM_EMAIL: "confirm-email",
    PAYMENT_AGREEMENT: "payment-agreement",
    OPT_IN: "opt-in",
    STATUSPAGE: "statuspage",
    PASSAGES: 'passages',
    BANNERS: 'banners'
};
